import React, { useState } from "react";
import styled from "@emotion/styled";
import { spacing, SpacingProps } from "@mui/system";

import { Alert as MuiAlert, Button as MuiButton } from "@mui/material";

import useAuth from "@/hooks/useAuth";
import { useSnackbar } from "@/contexts/SnackbarContext";

const Alert = styled(MuiAlert)(spacing);

interface ButtonProps extends SpacingProps {
  component?: React.ElementType;
  to?: string;
  target?: string;
}

const Button = styled(MuiButton)<ButtonProps>(spacing);

function SignIn() {
  const { signIn } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { showSnackbar } = useSnackbar();

  const handleSignIn = async () => {
    setError(null);
    setIsLoading(true);

    try {
      await signIn();
    } catch (error: any) {
      setError(error.message || "Something went wrong during sign-in.");
      showSnackbar("Sign-In Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <Button
        ml={2}
        color="primary"
        // variant="outlined"
        onClick={handleSignIn}
        disabled={isLoading}
        sx={{
          // backgroundColor: 'hsl(212, 70%, 39%)',
          color: "hsl(212, 70%, 39%)",
          fontWeight: 600,
          fontSize: 18,
          padding: "10px 20px",
        }}
      >
        {isLoading ? "Signing in..." : "Sign in"}
      </Button>
    </>
  );
}

export default SignIn;
